import "./_bio.css";
import React from "react";

export const Bio = () => {
    return (
        <div className="privacy">
            <div className="privacy-section">
                <h1><b>Bouns'Bot</b> history</h1>
            </div>
            <div className="privacy-section">
                <p><b>Bouns'bot</b> is a bot born from a passion for development and programming<br /> made by <b>BadbounsTV</b></p>
                <p>The bot is constantly evolving, and is regularly updated.</p>
                <p>it is currently in version <b>2.XX.XX</b></p>

                <p>The philosophy of <b>Bouns'bot</b> is to offer a complete, quality bot, with all the features you would expect from a bot, all for free!</p>
                <p>Many features available on <b>Bouns'bot</b> are exclusive features, and not available on any other bot.</p>

                <p>data is stored on a private server, and is not shared with third parties.</p>
                <p>the <b>data</b> is used only for the proper functioning of the bot, and is not used for commercial purposes.</p>
                <p>the <b>data</b> are deleted at the <b>user's request</b></p>
                <p><b>Bouns'bot</b> is a <b>100% free</b> bot, and does not require any bank details.</p>

                <p>If you have any questions, or if you want to contact us, you can contact us on our discord server: <a href="https://discord.gg/KxedRVTutX">https://discord.gg/KxedRVTutX </a></p>
            </div>
        </div>
    );
};